import Vue from 'vue';
import {
  CART_DISPLAY,
  CART_ITEM_REMOVE,
  CART_ITEM_SET_QUANTITY,
  CART_RESET,
  CART_ITEM_UPDATE,
  CART_CLEAR_USER_ORDERS,
  ORDER_LOAD,
  ORDER_SET_RESTAURANT,
  ORDER_SET_TYPE,
  ORDER_CREATE,
  ORDER_SET_TERMINAL,
  ORDER_RESET,
  SHOW_CHECKOUT_DIALOG,
  HIDE_CHECKOUT_DIALOG,
  ORDER_CALC,
  SET_DISCOUNT_CODE_UPDATING,
  SET_DISCOUNT_ERRORS,
  DISCOUNT_CODE_CHANGED,
} from './types';

export default {
  /**
   * Sets display data for cart
   * @param state
   * @param {boolean} value - defines if cart should be displayed.
   */
  [CART_DISPLAY]: (state, value) => {
    state.cartDisplay = value;
  },
  /**
   * Set order item in cart
   * @param state
   * @param orderItemId
   * @param orderItem
   */
  [CART_ITEM_UPDATE]: (state, { orderItemId, orderItem = {} }) => {
    Vue.set(state.cartContent, orderItemId, orderItem);
  },

  /**
   * Remove item from the cart by ID
   * @prop itemId - id of item in cart
   */
  [CART_ITEM_REMOVE]: (state, itemId) => {
    Vue.delete(state.cartContent, itemId);
  },

  /**
   * Remove item from the cart by ID
   * @prop itemId - id of item in cart
   * @prop quantity - new quantity of item
   */
  [CART_ITEM_SET_QUANTITY]: (state, { itemId, quantity }) => {
    Vue.set(state.cartContent[itemId], 'quantity', quantity);
  },

  /**
   * Remove all items from cart
   */
  [CART_RESET]: (state) => {
    state.order = null;
    state.calculatedOrder = null;
    Vue.set(state, 'cartContent', {});
  },

  /**
   * Set selected order type.
   * @param orderType - one of `ORDER_TYPES`
   */
  [ORDER_SET_TYPE]: (state, orderType) => {
    state.orderType = orderType;
  },

  /**
   * Set selected rest.
   * @param restaurantId - restaurant id
   */
  [ORDER_SET_RESTAURANT]: (state, restaurantId) => {
    state.restaurantId = restaurantId;
  },

  /**
   * Set selected terminal.
   * @param terminalId - terminal id
   */
  [ORDER_SET_TERMINAL]: (state, terminalId) => {
    state.terminalId = terminalId;
  },
  /**
   * Save order data.
   * @param state
   * @param order
   */
  [ORDER_CREATE]: (state, order) => {
    state.order = order;
  },
  /**
   * Save calculated order.
   * @param state
   * @param order
   */
  [ORDER_CALC]: (state, order) => {
    state.calculatedOrder = order;
  },
  /**
   * Reset order data.
   */
  [ORDER_RESET]: (state) => {
    state.order = null;
    state.calculatedOrder = null;
  },
  /**
   * Set already created orders for current user.
   */
  [ORDER_LOAD]: (state, order) => {
    state.userOrders.push(order);
  },

  /**
   * Clear user orders.
   */
  [CART_CLEAR_USER_ORDERS]: (state) => {
    state.userOrders = [];
    state.order = null;
    state.calculatedOrder = null;
  },

  /**
   * Show checkout modal mutation.
   * @param state
   */
  [SHOW_CHECKOUT_DIALOG]: (state) => {
    state.checkoutModalDisplay = true;
  },

  /**
   * Hide checkout modal mutation.
   * @param state
   */
  [HIDE_CHECKOUT_DIALOG]: (state) => {
    state.checkoutModalDisplay = false;
  },

  [SET_DISCOUNT_CODE_UPDATING]: (state, isUpdating) => {
    state.discountCodeIsUpdating = isUpdating;
  },

  [SET_DISCOUNT_ERRORS]: (state, errors) => {
    state.discountErrors = errors;
  },

  [DISCOUNT_CODE_CHANGED]: (state, discountCode) => {
    state.discountCode = discountCode;
  },
};



// WEBPACK FOOTER //
// ./src/apps/cart/store/mutations.js